import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

const ContactForm = ({ data }) => {
  return (
    <div className="flex flex-col overflow-hidden rounded-2xl bg-[#031416] text-white">
      <Image
        src={`${process.env.NEXT_PUBLIC_API_URL}/assets/${data?.form_img?.id}`}
        alt=""
        width={300}
        height={300}
        priority
        quality={100}
        className="w-full h-auto object-fill"
      />

      <div className="flex flex-col gap-[24px] p-[24px] w-full">
        <div className="flex flex-col w-auto text-center gap-[8px]">
          <h2 className="font-bold text-[24px] text-center font-inter-tight">
            {data?.form_heading}
          </h2>
          <p className="text-[16px] text-center font-inter">
            {data?.form_description}
          </p>
        </div>

        <Link
          href={data?.form_btn_url}
          className="h-[52px] w-full flex items-center justify-center text-white hover:bg-white z-30 hover:text-black transition-all md:duration-300 duration-100 rounded-full text-[16px] font-semibold font-inter bg-transparent border-2 px-6 mt-5 border-white"
        >
          {data?.form_btn}
        </Link>
      </div>
    </div>
  );
};

export default ContactForm;
